import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap, map, shareReplay } from "rxjs/operators";

import { Currency } from "src/app/shared/models/currency.interface";
import { SelectOption } from "src/app/shared/models/select-option.interface";
import { sortAsc } from "src/app/shared/utils/sort.util";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root"
})
export class CurrencyService {
	private readonly http = inject(HttpClient);

	private readonly currencies$ = this.http.get<Currency[]>(`${environment.apiUri}/v1/resources/currencies`).pipe(
		tap((currency: Currency[]) => {
			sortAsc(currency, ["code"]);
		}),
		shareReplay({ bufferSize: 1, refCount: false })
	);

	getAllCurrencies(): Observable<Currency[]> {
		return this.currencies$;
	}

	getCurrencyOptions(selected = false): Observable<SelectOption[]> {
		return this.getAllCurrencies().pipe(
			map((currencies: Currency[]) => {
				return currencies.map(currency => {
					const option: SelectOption = {
						value: currency.code,
						text: currency.code + " - " + currency.name,
						placeholder: currency.code
					};

					if (selected) {
						option.selected = false;
					}

					return option;
				});
			})
		);
	}
}
